export const useActionKey = () => document?.querySelector('meta[name="ak"]')?.getAttribute('content') || '';
